<template>
  <div
    class="v-overlay v-overlay--active"
    style="z-index: 202; background-color: rgb(33, 33, 33, 0.46); border-color: rgb(33, 33, 33, 0.46);"
    v-if="imageDialog"
    @click="imageDialog = false"
  >   
  <!-- <div class="v-overlay__scrim" style="opacity: 0.46; background-color: rgb(33, 33, 33); border-color: rgb(33, 33, 33);"></div> -->
    <v-btn 
      style="position: absolute; top: 5px; right: 5px; z-index: 7; opacity: .8;"
      color="black" 
      fab
      small
    >
      <v-icon color="#fff">mdi-close</v-icon>
    </v-btn>
    <v-layout class="row wrap align-center fill-height" style="opacity: 1;">
        <v-flex class="text-align-center">
            <img class="elevation-7" 
                :src="imageSrc" 
                style="width: auto; height: auto; max-width: 90%; max-height: calc(100vh - 100px); position: relative; z-index: 6; margin: 0 auto; display: flex; background: white;" 
                @click.stop=""
            >
        </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data () {
    return {
      imageSrc: null,
      imageDialog: false
    }
  },
  mounted () {
    this.$root.$on('openImage', img => {
      this.showImage(img)
    })
  },
  beforeDestroy () {
    this.$root.$off('openImage', () => {})
  },
  methods: {
    showImage (img) {
      this.imageDialog = true
      this.imageSrc = img
    }
  }
}
</script>